function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10.5,
    viewBox: "0 0 10 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 95",
    d: "M10.5 4.212V3.5a3.5 3.5 0 1 0-7 0v.712A2.5 2.5 0 0 0 2 6.5v3A2.5 2.5 0 0 0 4.5 12h5A2.5 2.5 0 0 0 12 9.5v-3a2.5 2.5 0 0 0-1.5-2.288zm-6-.712a2.5 2.5 0 1 1 5 0V4h-5zm6.5 6A1.5 1.5 0 0 1 9.5 11h-5A1.5 1.5 0 0 1 3 9.5v-3A1.5 1.5 0 0 1 4.5 5h5A1.5 1.5 0 0 1 11 6.5z",
    style: {
      fill: "#050505"
    },
    transform: "translate(-2)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.5235a07d91e79d29f01012c9c95a1779.svg";
export { ForwardRef as ReactComponent };